export default class FormValidationError extends Error {
  fields: Record<string, string> = {};

  constructor() {
    super('Erro de validação de formulário.');
    this.fields = {};
  }

  add(field: string, message: string) {
    this.fields[field] = message;
  }

  get length() {
    return Object.keys(this.fields).length;
  }
}
